import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../audi-ui-components/Button';
import { gtmPush } from '../../../lib/gtm';
import { AUDI_SHOP_URL } from '../../../constants';
import Carousel from 'react-bootstrap/Carousel';

import Media from './../../../components/Media';

const RecommendedProducts = ({ products }) => {

  const item = (product) => (
    <>
      <a className="product"
        href={product.onlineStoreUrl}
        target="_blank" rel="noopener noreferrer"
        onClick={() => { gtmPush("myAudi", "audiStoreAu", product.onlineStoreUrl); }}
      >
        <Media
          type="image"
          url={product.images.edges[0].node.originalSrc}
          altText={`${product.title} image`} />
        <p className="product-name pt-4 pb-4">{product.title}</p>
        <div className="product-price aui-headline-6">${product.variants.edges[0].node.price}</div>
        <span className="aui-button aui-button--text"><span className="aui-button__text">Shop now</span></span>
      </a>
    </>);

  return (
    <div className="audi-store py-7">
      <div className="row">

        <div className="col-12 col-medium-3">
          <div className="row">
            <div className="">
              <h4 className="store-title mb-3 mb-6"><b>Curated for you from the Audi Store</b></h4>
              <Button label="Shop now"
                buttonType="primary"
                href={AUDI_SHOP_URL}
                rel="noopener noreferrer"
                target="_blank"
                onClick={() => { gtmPush("myAudi", "audiStoreAu", AUDI_SHOP_URL); }}
                className="mb-6 mb-medium-0 mt-medium-6"
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-medium-9">

          <div className="row carousel-version">
            <Carousel>
              {products && products.map(product =>
                <Carousel.Item key={product.handle}>
                  {item(product)}
                </Carousel.Item>
              )}
            </Carousel>
          </div>

          <div className="row no-carousel-version">
            {products && products.map(product => <div className="col" key={product.handle}>{item(product)}</div>
            )}
          </div>

        </div>

      </div>
    </div>
  );
};

export default RecommendedProducts;
